<template>
  <div class="d-flex flex-col align-items-center tw-my-24 md:tw-my-26">
    <img :src="NoDataImg" alt="" style="width: 150px; height: 150px" />
    <span style="text-align: center; color: #999; font-size: 14px"
      >暂无记录</span
    >
  </div>
</template>

<script>
import NoDataImg from "@/assets/user/no-data.png";
export default {
  name: "no-data",
  data() {
    return {
      NoDataImg,
    };
  },
  methods: {
    // 方法区
  },
};
</script>

<style lang="scss" scoped></style>
